import React, { useMemo } from "react";
import { getDaysInMonth, pad2OrDash } from "../lib/results";

/** Day-by-day grid for one month across the given games. */
const MonthlyChartTable = ({
  games,
  chartResults,
  selectedMonthIndex,
  selectedYear,
  isLoading,
}) => {
  const rows = useMemo(() => {
    const monthNum1 = selectedMonthIndex + 1;
    const days = getDaysInMonth(selectedYear, monthNum1);
    const out = [];

    for (let day = 1; day <= days; day += 1) {
      const row = { day, values: {} };
      games.forEach((g) => {
        const r = chartResults.find((x) => x.game.key === g.key);
        const monthData =
          r && r.monthDataByMonth ? r.monthDataByMonth[monthNum1] || {} : {};
        row.values[g.key] = monthData[day] ?? "XX";
      });
      out.push(row);
    }
    return out;
  }, [games, chartResults, selectedMonthIndex, selectedYear]);

  return (
    <>
      <div className="table-wrap">
        <table
          className={`results-table monthly-results-table${
            games.length === 1 ? " single-game-table" : ""
          }`}
        >
          <thead>
            <tr>
              <th scope="col">Date</th>
              {games.map((g) => (
                <th scope="col" key={g.key}>
                  {g.name}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, idx) => (
              <tr
                key={row.day}
                className={idx % 2 === 0 ? "row-odd" : "row-even"}
              >
                <th scope="row">{row.day}</th>
                {games.map((g) => (
                  <td key={g.key}>{pad2OrDash(row.values[g.key])}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {isLoading && (
        <div className="small muted" style={{ marginTop: 8 }}>
          Loading chart...
        </div>
      )}
    </>
  );
};

export default MonthlyChartTable;
